import { render } from "./UnidadMedidaCreate.vue?vue&type=template&id=186de438&scoped=true"
import script from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"
export * from "./UnidadMedidaCreate.vue?vue&type=script&lang=js"

import "./UnidadMedidaCreate.vue?vue&type=style&index=0&id=186de438&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186de438"]])

export default __exports__